
        var result = require("!!../../../../node_modules/css-loader/index.js!./supplier.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/supplier/supplier.component.css
// module id = 738
// module chunks = 0